document.addEventListener('DOMContentLoaded', () => {

  const SwiperCtor =
    window.Swiper ||
    (window.FoxTheme && FoxTheme.Swiper && FoxTheme.Swiper.Swiper);

  const reelsEl = document.querySelector('.video-reels-slider');

  if (reelsEl && SwiperCtor) {
    new SwiperCtor(reelsEl, {
      slidesPerView: 2.4,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 4.5
        }
      }
    });
  }

  document.querySelectorAll('.video-thumb').forEach(item => {

    item.addEventListener('click', () => {

      const modal = document.querySelector('#video-reels-modal');
      const video = modal.querySelector('video');

      video.src = item.dataset.video;
      video.play();

      modal.classList.add('active');

      modal.querySelector('.video-shop-btn').href = item.dataset.link;

      modal.querySelector('.video-product-title').innerText =
        item.dataset.title;

      modal.querySelector('.video-product-image').src =
        item.dataset.image;

    });

  });

  document.querySelector('.video-close')?.addEventListener('click', () => {

    const modal = document.querySelector('#video-reels-modal');

    modal.classList.remove('active');

    modal.querySelector('video').pause();

  });

});